// What a support request can be about — the list behind both "Choose your
// reason" fields on the Support tab.
//
// One list for the enquiry and the call, because they are the same subjects
// asked about two ways, and a reason that can be typed into one but not the
// other would be a distinction nobody reading the screen could explain.
//
// A fixed list rather than a free-text subject line: it is what lets a request
// reach the right person without anybody reading it first, and the box under it
// is where anything the list does not cover goes.

export const SUPPORT_REASONS = [
  "Account setup",
  "Billing and payments",
  "Clients and enquiries",
  "Meal plans",
  "My brand and public page",
  "Something is broken",
  "Something else",
];
